export default __webpack_public_path__ + "static/media/navbar-services-orange.1410f8c4.svg";